import {createCountersSocket} from '../api';
import Map from '../map';
import {AllTimeCounters} from '../counters';

let map;

export function setup() {
    map = new Map(document.querySelector('#map'), {
        mapTypeId: 'satellite',
    });

    createCountersSocket('home', new AllTimeCounters())
      .on('visit', (v) => map.addVisitorMarker(v));
}
